import { render, staticRenderFns } from "./TabbedNav.vue?vue&type=template&id=3055a55c&"
import script from "./TabbedNav.vue?vue&type=script&lang=ts&"
export * from "./TabbedNav.vue?vue&type=script&lang=ts&"
import style0 from "./TabbedNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports